import React from "react";
import StaticPageTemplate from "../StaticPage/StaticPageTemplate";

const Tutorial = () => {
  return (
    <StaticPageTemplate
      slug="tutorial"
      defaultTitle="Tutorial"
      defaultFeatureImage="https://storage.googleapis.com/road-to-fe/uploads/1741110100881-3352082b-c129-4963-b7ec-31bb27177882-tutorial.webp"
    />
  );
};

export default Tutorial;
